import { useState, useRef } from "react";
import { MUSIC_URL } from "@/lib/constants";
import { Music, Pause } from "lucide-react";

export default function MusicPlayer() {
  const [playing, setPlaying] = useState(false);
  const audioRef = useRef(null);

  const toggle = () => {
    const a = audioRef.current;
    if (!a) return;
    if (playing) {
      a.pause();
      setPlaying(false);
    } else {
      a.volume = 0.35;
      a.play().then(() => setPlaying(true)).catch(() => setPlaying(false));
    }
  };

  return (
    <>
      <audio ref={audioRef} src={MUSIC_URL} loop preload="none" />
      <button
        onClick={toggle}
        data-testid="music-toggle-btn"
        title={playing ? "Pause piano music" : "Play soft piano music"}
        className="fixed bottom-5 right-5 z-50 w-14 h-14 rounded-full btn-silver-3d !p-0"
        aria-label="Toggle background music"
      >
        {playing ? (
          <Pause className="w-6 h-6" style={{ color: "#9b111e" }} />
        ) : (
          <Music className="w-6 h-6" style={{ color: "#9b111e" }} />
        )}
      </button>
    </>
  );
}
